import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./components/sections/Hero";
import AboutUs from "./components/sections/AboutUs";
import Features from "./components/sections/Features";
import WhyChooseUs from "./components/sections/WhyChooseUs";
import CTA from "./components/sections/CTA";
import BusinessUnits from "./components/sections/BusinessUnit";
import Journey from "./components/sections/Journey";

function App() {
  return (
    <div className="bg-base min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <AboutUs />
        <Features />
        <BusinessUnits />
        <Journey />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
